import _styled from '@emotion/styled/base';
import { TYPOGRAPHY_STYLE } from '../typography/index.js';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import SPACER from '../../constants/spacer/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import { applyPrimaryThemeVerticalOffset } from '../../utils/themeStyles/index.js';

var IndicatorContainer = _styled("div", {
  target: "e1omq9po0",
  label: "IndicatorContainer"
})("background-color:", _ref => {
  var {
    backgroundColor
  } = _ref;
  return backgroundColor;
}, ";min-height:16px;height:16px;max-height:16px;text-align:center;padding:0 ", SPACER.xsmall, ";min-width:16px;width:fit-content;box-sizing:border-box;display:flex;justify-content:center;align-items:center;border-radius:50%;>div{", _ref2 => {
  var {
    theme
  } = _ref2;
  return TYPOGRAPHY_STYLE.label(theme);
}, " font-weight:", _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.TYPOGRAPHY.fontWeight.bold;
}, ";color:", _ref4 => {
  var {
    textColor
  } = _ref4;
  return textColor;
}, ";", _ref5 => {
  var {
    theme
  } = _ref5;
  return applyPrimaryThemeVerticalOffset(theme);
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlzQyIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRZUE9HUkFQSFlfU1RZTEUgfSBmcm9tICcuLi90eXBvZ3JhcGh5JztcbmltcG9ydCB7IFNQQUNFUiB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5pbXBvcnQgeyBhcHBseVByaW1hcnlUaGVtZVZlcnRpY2FsT2Zmc2V0IH0gZnJvbSAnLi4vLi4vdXRpbHMvdGhlbWVTdHlsZXMnO1xuY29uc3QgSW5kaWNhdG9yQ29udGFpbmVyID0gc3R5bGVkLmRpdiBgXG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgYmFja2dyb3VuZENvbG9yIH0pID0+IGJhY2tncm91bmRDb2xvcn07XG4gIG1pbi1oZWlnaHQ6IDE2cHg7XG4gIGhlaWdodDogMTZweDtcbiAgbWF4LWhlaWdodDogMTZweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBwYWRkaW5nOiAwICR7U1BBQ0VSLnhzbWFsbH07XG4gIG1pbi13aWR0aDogMTZweDtcbiAgd2lkdGg6IGZpdC1jb250ZW50O1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuXG4gID4gZGl2IHtcbiAgICAkeyh7IHRoZW1lIH0pID0+IFRZUE9HUkFQSFlfU1RZTEUubGFiZWwodGhlbWUpfVxuICAgIGZvbnQtd2VpZ2h0OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLlRZUE9HUkFQSFkuZm9udFdlaWdodC5ib2xkfTtcbiAgICBjb2xvcjogJHsoeyB0ZXh0Q29sb3IgfSkgPT4gdGV4dENvbG9yfTtcbiAgICAkeyh7IHRoZW1lIH0pID0+IGFwcGx5UHJpbWFyeVRoZW1lVmVydGljYWxPZmZzZXQodGhlbWUpfTtcbiAgfVxuYDtcbmV4cG9ydCBkZWZhdWx0IHsgSW5kaWNhdG9yQ29udGFpbmVyIH07XG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZS5qcy5tYXAiXX0= */"));

var Style = {
  IndicatorContainer
};

export { Style as default };
